/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ErrorMessage } from "formik";
import React from "react";
import { IFormikErrorMessageProps } from "./IFormikErrorMessageProps";
import { RedText } from "./FormikErrorMessage.styles";

/**
 * Formik Error Message.
 * @component
 * @returns {React.ReactElement<IFormikErrorMessagesProps>}
 */
export default function FormikErrorMessage(props: IFormikErrorMessageProps): React.ReactElement {
  return (
    <ErrorMessage
      name={props.name}
      render={(msg: string): React.ReactElement => (
        <div role="alert" aria-relevant="all">
          <RedText className="error"> {msg} </RedText>
        </div>
      )}
    />
  );
}
